import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import Img from "gatsby-image";
import styles from "./NextCaseStudy.module.scss";
import Arrow from "../../img/arrow-right-up.svg";
import HoverEffect from "../_Common/HoverEffect";

const NextCaseStudy = ({ title, path, featuredImage, name }) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <Link to={path}>
        <HoverEffect>
          <Img fluid={featuredImage.fluid} />
        </HoverEffect>
      </Link>
      <Link className={styles.name} to={path}>
        {name}
      </Link>
      <Link className={styles.title} to={path}>
        {title}
      </Link>
      <Link className={styles.next} to={path}>
        Next Project <Arrow className={styles.arrow} />
      </Link>
    </div>
  </div>
);

NextCaseStudy.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  shortDescription: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  featuredImage: PropTypes.object.isRequired
};

export default NextCaseStudy;
